/**
 * Splide Carousel Initialization
 *
 * Initializes Splide for visual4 carousel blocks.
 */

import Splide from '@splidejs/splide';

document.addEventListener( 'DOMContentLoaded', initCarousels );

function initCarousels() {
    const carousels = document.querySelectorAll(
        '.wp-block-visual4-carousel.splide:not(.is-initialized)'
    );

    if ( ! carousels.length ) {
        return;
    }

    carousels.forEach( ( carousel ) => {
        const track = carousel.querySelector( '.splide__track' );
        const list = carousel.querySelector( '.splide__list' );
        const slides = carousel.querySelectorAll( '.splide__slide' );

        if ( ! track || ! list || ! slides.length ) {
            return;
        }

        new Splide( carousel, {
            type: 'slide',
            perPage: 4,
            perMove: 1,
            gap: 'var(--wp--style--block-gap, 1rem)',
            padding: { right: 'calc(2 * var(--wp--style--block-gap, 1rem))' },
            arrows: true,
            arrowPath: 'M30.1,18.9c.6.6.6,1.6,0,2.2l-18,18.5c-.6.6-1.5.6-2.1,0-.6-.6-.6-1.6,0-2.2l16.9-17.4L9.9,2.6c-.6-.6-.6-1.6,0-2.2.6-.6,1.5-.6,2.1,0l18,18.5Z',
            pagination: false,
            drag: true,
            rewind: true,
            speed: 400,
            autoplay: false,
            interval: 5000,
            pauseOnHover: true,
            pauseOnFocus: true,
            breakpoints: {
                1024: { perPage: 2 },
                640: { perPage: 1 },
            },
        } ).mount();
    } );
}